import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
  Theme,
} from '@material-ui/core';
import React from 'react';

interface IProps {
  open: boolean;
  title: string;
  content: string;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
interface IStyleProps {
  loading: boolean;
}
const useStyles = makeStyles<Theme, IStyleProps>(() => ({
  root: {
    pointerEvents: ({ loading }) => (loading ? 'none' : 'all'),
  },
  dialogTitle: {
    color: 'black',
  },
}));

const ConfirmDialog: React.FC<IProps> = ({
  open,
  title,
  content,
  onClose,
  onConfirm,
  loading,
}) => {
  const { root, dialogTitle } = useStyles({ loading });
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className={root}
    >
      <DialogTitle id="alert-dialog-title">
        <span className={dialogTitle}>{title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" autoFocus variant="outlined">
          ยกเลิก
        </Button>
        <Box display="flex" justifyContent="center" ml={1} position="relative">
          <Button
            onClick={onConfirm}
            color="primary"
            variant="contained"
            disabled={loading}
          >
            ยืนยัน
          </Button>
          {loading && (
            <Box
              position="absolute"
              top="50%"
              left="50%"
              marginTop={'-12px'}
              marginLeft={'-12px'}
            >
              <CircularProgress size={26} />
            </Box>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
